<template>
    <div>
        <section class="content-header">
            <ol class="breadcrumb">
            </ol>
        </section>
        <section class="content" style="margin-top:-30px;">
            <div class="defaultPage" id="defaultPage">
                <el-row :gutter="20">
                    <el-col style="padding-left: 10px;padding-right: 10px;">
                        <div class="title"><h1>预存剩余</h1>
                        </div>
                        <div class="grid-content bigCard">
                            <el-table :data="remain" stripe border style="width: 100%" class="cd-todoTable">
                                <el-table-column label="商户" prop="merchant_name" align="center"></el-table-column>
                                <el-table-column label="剩余笔数" prop="search_amount" align="center"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col style="padding-left: 10px;padding-right: 10px;">
                        <div class="title"><h1>上月业绩</h1>
                        </div>
                        <div class="grid-content bigCard">
                            <el-table :data="staticsDataPre" stripe border style="width: 100%" class="cd-todoTable">
                                <el-table-column v-for="(item,index) in tableHeadPre"
                                                 :key="index"
                                                 :label="item.label"
                                                 :prop="item.prop"
                                                 show-overflow-tooltip
                                                 align="center"
                                                 :fixed="item.prop == 'merchant_name' || item.prop == 'merchant_id'"
                                >
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col style="padding-left: 10px;padding-right: 10px;">
                        <div class="title"><h1>本月业绩</h1>
                        </div>
                        <div class="grid-content bigCard">
                            <el-table :data="staticsDataCur" stripe border style="width: 100%" class="cd-todoTable">
                                <el-table-column v-for="(item,index) in tableHeadCur"
                                                 :key="index"
                                                 :label="item.label"
                                                 :prop="item.prop"
                                                 show-overflow-tooltip
                                                 align="center"
                                                 :fixed="item.prop == 'merchant_name' || item.prop == 'merchant_id'"
                                >
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
    </div>
</template>
<script>
    import $ from 'jquery'

    let _p = global.xwCommon, pageTitle = "常用功能",
    methods = {
        merchantBalance() {
            let url = _p.getApiUrl('finance/remain');
            $.get(url, {'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id} ,(json) => {
                this.remain = json.data
            })
        },
        creditStaticsPre() {
            let url = _p.getApiUrl("searchCredit/statics"),month=new Date().getFullYear() + '-' + new Date().getMonth();
            $.get(url, {'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id, 'month': month} ,(json) => {
                this.staticsDataPre = json.data.statics_data
                json.data.title.forEach((tl, index) => {
                    //这里是根据数据循环得到的动态的表头
                    if(index == 0){
                        this.tableHeadPre.push({ label: tl, prop: 'merchant_name' }); // 动态表头
                    }else {
                        this.tableHeadPre.push({label: tl, prop: tl}); // 动态表头
                    }
                });
            })
        },
        creditStaticsCur() {
            let url = _p.getApiUrl("searchCredit/statics"),month=new Date().getFullYear() + '-' + (new Date().getMonth()+1);
            $.get(url, {'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id, 'month': month} ,(json) => {
                this.staticsDataCur = json.data.statics_data
                json.data.title.forEach((tl, index) => {
                    //这里是根据数据循环得到的动态的表头
                    if(index == 0){
                        this.tableHeadCur.push({ label: tl, prop: 'merchant_name' }); // 动态表头
                    }else {
                        this.tableHeadCur.push({label: tl, prop: tl}); // 动态表头
                    }
                });
            })
        }
    }

    export default {
        methods,
        data: () => {
            return {
                pageTitle,
                auto_: "230px",
                left: "left",
                role_oper_type: "",
                depart_id: "",
                // screenWidth: document.body.clientWidth,
                isWidth100: false,
                remain: [],
                tableHeadPre:[],
                tableHeadCur:[],
                staticsDataPre:[],
                staticsDataCur:[]
            }
        },
        created() {
            document.documentElement.scrollTop = 0;
        },
        watch: {
            /*screenWidth(val) {

                if (!this.timer) {
                    this.screenWidth = val
                    let part1 = document.getElementById("part1");
                    let part4 = document.getElementById("part4");
                    if (part4) {
                        part4.style.width = "100%"
                    }
                    if (this.screenWidth) {
                        if (this.screenWidth < 1595) {
                            if (part1) {
                                part1.style.width = "100%"
                            }
                        } else {
                            part1.style.width = "100%";
                        }
                    }
                    this.timer = true
                    let that = this
                    setTimeout(function () {
                        console.log(that.screenWidth)
                        that.timer = false
                    }, 400)
                }
            }*/
        },
        mounted() {
            let userinfo = _p.getStoredProp("staff/query")
            this.role_oper_type = userinfo.role_oper_type
            this.depart_id = userinfo.depart_id
            this.merchantBalance()
            this.creditStaticsPre()
            this.creditStaticsCur()
            window.xwStored.topCarTab.ref ? this.topCarTab = true : this.topCarTab = false;

            if (document.body.clientWidth < 1595) {
                this.isWidth100 = true
            } else {
                this.isWidth100 = false
            }
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
            _p.setTitle(pageTitle)

        },


    };
</script>
<style>
    .countCardBottom .v-charts-data-empty {
        position: absolute;
        top: 30%;
        right: 40%;
    }
</style>
<style scoped>
    .defaultPage .title {
        margin: 25px 5px;
    }

    .countCardTop img {
        width: 120px;
    }

    .bigCard {
        padding: 15px;
        height: 470px !important
    }

    .bigCard .countCardTop {
        border-bottom: 1px solid #d4c3c3;
        padding: 10px;
        position: relative;
        width: 100%;
        height: 150px;
    }

    .countCardTop .cardLeft {
        width: 50%;
        min-width: 336px;
        position: absolute;
        padding: 40px 65px;
    }

    .countCardTop .padding4030 {
        padding: 40px 30px;
    }

    .countCardTop .cardright {
        width: 50%;
        float: right;
        text-align: center;
    }

    .bigCard .countCardTop span {
        color: #FF9900;
    }

    .bigCard .countCardBottom {
        position: relative;
        width: 100%;
        text-align: center;
        padding-top: 15px;
    }

    .countCardBottom .cardLeft {
        width: 50%;
        position: absolute;
        min-width: 336px;
    }

    .countCardBottom .cardright {
        width: 50%;
        float: right
    }

    .countCardBottom p {
        margin: 15px 94px 0 94px;
    }

    .todoBtn {
        height: 50px;
        position: relative;
        line-height: 50px;
        margin-top: 40px;
    }

    .todoBtn h1 {
        float: left;
        margin-right: 40px;
        margin-top: 15px;
    }

    .todoTable .row {
        text-align: center;
        line-height: 500px;
    }

    #defaultImg img {
        max-width: 100%;
    }

    .defaultPage h1 {
        font-size: 24px;
    }

    .defaultPage .el-col {
        background-color: #ecf0f5;
        min-width: 667px;
    }

    .grid-content > span {
        line-height: 150px;
        position: absolute;
        margin: 0 30px;
        font-size: 22px;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        border: 1px solid #ccc;
        background-color: #fff;
        height: 150px;
        min-width: 667px;
        overflow: auto;
    }

    .buttonGroup {
        line-height: 150px;
        margin-left: 33px;
    }

    .buttonGroup li {
        float: left;
        margin-left: 20px;
        list-style: none;
    }

    .buttonGroup li span {
        display: inline-block;
        background-color: #337ab7;
        width: 100px;
        height: 80px;
        color: #fff;
        line-height: 80px;
        text-align: center;
        font-size: 21px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// homePage.vue?dae25678